import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const SectionWrapper = styled(Box)`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`
